import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    maxWidth: '400px',
    padding: '0',
    textAlign: 'left',
    transform: 'translate(-50%, -50%)',
    width: '500px',
  },
  overlay: {
    backgroundColor: 'rgb(0,0,0,0.5)',
  },
};

export const ChannelModalTypes = {
  CREATE: 'create',
  EDIT: 'edit',
};

const ErrorMessages = {
  EMPTY: 'Channel name must contain at least one character.',
  MAX_LENGTH: 'Channel name may not be more than 50 characters.',
};

/**
 * Validates the channels name.
 * The Name is valid is the length is greater than zero.
 * The Name is valid is the length is less o equal to 50 (limited by db field).
 *
 * @param {string} name - channel's name
 * @returns [{boolean}, {string}] - Array with the validation result.
 * A boolean that indicates wether the input is valid and a string with the error message.
 */
const validate = (name) => {
  if (name.length === 0) {
    return [false, ErrorMessages.EMPTY];
  }

  if (name.length > 50) {
    return [false, ErrorMessages.MAX_LENGTH];
  }

  return [true, ''];
};

const ChannelModal = ({ isOpen, handleOnClose, handleOnSubmit, initialName, type }) => {
  const [name, setName] = useState(initialName);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const title = type === ChannelModalTypes.CREATE ? 'New' : 'Edit';

  const [isValid, errorMessage] = validate(name);

  useEffect(() => {
    Modal.setAppElement('body');
  }, []);

  /**
   * Executes the onSubmit Callback if the name is valid.
   * The Name is valid is the length is greater than zero.
   *
   * @param {SyntheticEvent} event - event that triggers the form callback.
   * @returns void
   */
  const handleOnDone = (event) => {
    event.preventDefault();
    if (isValid) {
      setIsSubmitting(true);
      handleOnSubmit(name.trim());
    }
  };

  /**
   * Handle input channel's name input change event
   * Enforce no empty Channel Name
   * Enforce no extra whitespace (trim)
   *
   * @param {String} inputValue - name input value.
   * @returns void
   */
  const handleOnInputChange = (inputValue) => {
    if (inputValue !== ' ') {
      setName(inputValue.replace(/\s+/g, ' '));
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={() => handleOnClose()} style={customModalStyles}>
      <div className="channel-modal-content">
        <div className="modal-header">
          <h2 className="modal-title">{title} Channel</h2>
          <button type="button" className="anchor modal-closer" onClick={handleOnClose}>
            &nbsp;
          </button>
        </div>
        <div className="channel-inner-container">
          <form id="ChannelForm" className="modal-form" onSubmit={handleOnDone}>
            <label htmlFor="channelName">
              Name
              <input
                id="channelName"
                name="channelName"
                className="single-input"
                type="text"
                value={name}
                onChange={(e) => handleOnInputChange(e.target.value)}
                disabled={isSubmitting}
              />
            </label>
          </form>
        </div>
        <div className="modal-footer">
          {!isValid && <div className="validation">{errorMessage}</div>}
          <button
            type="submit"
            id="saveChannel"
            className="btn med-blue save-channel"
            disabled={!isValid || isSubmitting}
            onClick={handleOnDone}
          >
            {`${isSubmitting ? 'submitting...' : 'Save'}`}
          </button>
          <button type="button" className="modal-closer-text" onClick={handleOnClose}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

ChannelModal.defaultProps = {
  initialName: '',
};

ChannelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  initialName: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default ChannelModal;
